/**
 * User utilites
 *
 * @date 2024/04/09
 */
import * as _ from 'lodash-es';

import { isProdEnv } from '@/config';
import { AuthUser } from '@/types';

const taksoAIAdmins = {
  staging: [
    'beinanwangcanada@gmail.com',
    'eddiehaddadin@gmail.com',
    'lwz7512@gmail.com',
    'renedsm@gmail.com',
    'simonsottile@trentu.ca',
    'simon.i.sottile@gmail.com',
    'ssottile@taksoai.com',
    'wchiykowski@taksoai.com',
  ],
  production: [
    'eddiehaddadin@gmail.com',
    'lwz7512@gmail.com',
    'renedsm@gmail.com',
    'simonsottile@trentu.ca',
    'simon.i.sottile@gmail.com',
    'ssottile@taksoai.com',
  ],
};

/**
 * check tool `setting` button availability method
 * @param email
 * @returns
 */
export const isHardCodedAdmin = (email: string) => {
  const { staging, production } = taksoAIAdmins;
  if (isProdEnv) return production.includes(email);
  return staging.includes(email);
};

enum USER_STATUS {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
}

/**
 * TODO: to improve...only check if user is `taksoai` ADMIN!
 * @deprecated
 * @param user
 * @returns
 */
export const isAdmin = (user: AuthUser | undefined | null) => {
  return false;
  // if (!user) return false;
  // const roleName = _.get(user, 'company_roles[0].roles[0].name');
  // return roleName === 'ADMIN';
};

/**
 * @deprecated
 * @param user
 * @returns
 */
export const isActiveUser = (user: AuthUser) =>
  user.status == USER_STATUS.ACTIVE;
